//Shared
import { CustomMessageService } from '@app/shared/components/custom-message/custom-message.service';
import { LoggerService } from '@app/logger/logger.service';
import { CustomDialogComponent } from '@app/custom-material/custom-dialog/custom-dialog.component';
//Entities
import { ManufacturerService } from '@app/shared/services/entities/manufacturers.service';
import { FamilyService } from '@app/shared/services/entities/family.service';
import { ProductsService } from '@app/shared/services/entities/products.service';
import { StockService } from '@app/shared/services/entities/stock.service';
//Angular
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { DialogData } from '@app/shared/models/custom-dialog.model';
import pt from 'date-fns/locale/pt';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';
const log = new LoggerService('INTERVENTION DIALOG COMPONENT');

@Component({
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
],
  selector: 'app-aduana-dialog',
  templateUrl: './aduana-dialog.component.html',
  styleUrls: ['./aduana-dialog.component.scss']
})
export class AduanaDialogComponent implements OnInit {
  uiData: any[] = [];
  stock: any[] = [];
  products: any[] = [];

  public manufacturerList:any[] = [];
  public familyList:any[] = [];

  constructor(
    public dialogRef: MatDialogRef<AduanaDialogComponent>,
    private dialog: MatDialog,
    //Entities
    private manufacturerService: ManufacturerService,
    private familyService: FamilyService,
    private stockService: StockService,
    private productService: ProductsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private customMessageService: CustomMessageService,
  ) { 
    console.log('[constructor] data', data);
    this.stock = data.stock;
    this.products = data.products;
  }

  async ngOnInit() {
    this.customMessageService.open({title: 'Espere', type: 'neutral', message: `Cargando información...`, loading: true });
    await this.getEntityDataManufacturer();
    await this.getEntityDataFamilies();
    this.setUiData();
    this.customMessageService.close();
  }

  async getEntityDataManufacturer() {
    try{
      let apiResponse = await this.manufacturerService.search({searchType:'default',condition:{deleted:false}})
      if (apiResponse.state === 'success') {
        this.manufacturerList = apiResponse.data;
      } else {
        throw new Error(apiResponse.message);
      }
    }
    catch(err){
      throw err;
    }
  }

  async getEntityDataFamilies() {
    try{
      const apiResponse = await this.familyService.search({searchType:'default',condition:{deleted:false}})
      if (apiResponse.state === 'success') {
        this.familyList = apiResponse.data;
      }
    }catch(err){
      throw err;
    }
  }

  setUiData(){
    this.uiData = this.products.map(prod =>{
      return {
        code: prod.code,
        description: prod.description,
        id: prod.id,
        accepted: false,
        //Filtrar el stock que corresponde al producto
        items: this.stock.filter(stk => stk.product === prod.id)
      };
    });
    console.log('[setUiData] uiData', this.uiData)
  }

  acceptProduct(event: Event, id: string){
    let product = this.products.find(o => o.id === id);
    event.stopPropagation();// Evitar que el acordeón se abra/cierre al hacer clic en el botón
    let inputs:any[] = [{'name': 'code','displayName': 'Código','type': 'text','required': true},
                          {'name': 'description','displayName': 'Descripción','type': 'text','required': true},
                          {'name': 'manufacturer', 'displayName': 'Fabricante', 'type': 'select', 'options': this.manufacturerList, 'required': true},
                          {'name': 'family', 'displayName': 'Categoria', 'type': 'select', 'options': this.familyList, 'required': true},
                          {'name': 'usageFactor', 'displayName': 'Factor de Uso', 'type': 'number', 'required': true},
                          {'name': 'UOM', 'displayName': 'Unidad de Medida', 'type': 'select', 'options': [{id: 'Caja', name: 'Caja'}, {id: 'Pza', name: 'Pieza'}],'required': true}];
    let forms = inputs.map(({name, displayName, type, required, options}) => ({
        key: name,
        label: displayName,
        type:  type, //type === 'select' ? 'multiselect': type,
        required: required,
        ...(options && { options: options.map(({ id, name }) => ({ label: name, value: id })) }), //Si el input incluye opciones, obtener su label y value
        ...(product && product[name] !== undefined && { value: product[name] }), //Si se manda un elemento (cuando type = update), enviar el valor actual
      }))
      console.log('[openDynamicDialog] forms', forms)
      
      let config: DialogData = {
        title: `Agregar Insumo`,
        fields: forms
      };
    
      const dialogRef = this.dialog.open(CustomDialogComponent, {
        data: config,
        width: '600px'
      });

      dialogRef.afterClosed().subscribe(async result => {
        console.log('acceptProduct] result', result)
        if (result) {
          const i = this.uiData.findIndex(d => d.code === result.code);
          console.log('acceptProduct] i', i)
          if(i !== -1)this.uiData[i].accepted = true;
          console.log('acceptProduct] uiData', this.uiData)
          //Update product
          result.active = true;
          const productResponse = await this.productService.update(result);
          //Update stock
          let stock = this.stock.filter(stk => stk.product === result.id);//filtrar el stock de ese producto
          stock.forEach(stk => stk.status = 'Disponible');
          const stockResponse = await this.stockService.update(stock);
        }
      });
  }

}